
import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../../core/user/user.service';
import { Language } from '../../_enum/constants';
import { TermsAndConditionsService } from './services/terms-and-conditions.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DGSNSupport } from '../../../../library/sharedDVLibrary/angular-shared-component/projects/angular-v21/src/lib/shared/enum/constants';
import { ErrorMsgType } from './_enum/constants';
@Component({
    selector: 'nalco-terms-and-conditions-modal',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class TermsAndConditionsComponent implements OnDestroy {

  @Input() showHyperLink = false;
  @Input() serviceTypeId = 0;
  @Input() widgetTitle = '';
  @Input() id = 0;
  @Input() ssdCreateNewEditView = false;
  @ViewChild('termsAndConditionsModal', { static: false }) termsAndConditionsModal;
  @Output() termsAndConditionsAcceptState: EventEmitter<number> = new EventEmitter<number>();
  termsAndConditionsmodalRef: NgbModalRef;
  subscriptions: Subscription[] = [];
  sanitizedHtml: SafeHtml;
  isTCAccepted = false;
  supportEmailId = DGSNSupport.Email;

  LanguageListDropdown = {
    label: this.translate.instant('COMMON.SELECT'),
    name: 'select',
    options: []
  };
  private selectedLanguageCulture = 'en-US';
  private termsAndConditionsId: number;
  @Output() onCloseTermsAndConditions: EventEmitter<string> = new EventEmitter<string>();
  @Output() onWidgetRemove: EventEmitter<{id: number, serviceTypeId: number}> = new EventEmitter<{id: number, serviceTypeId: number}>();
  showLoader = false;
  errorMsgType: ErrorMsgType = ErrorMsgType.NO_ERROR;
  isCheckboxDisabled = true;
  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private termsAndConditionsService: TermsAndConditionsService,
    private router: Router
  ) {
  }

  ngOnInit() {
    if (!this.showHyperLink) {
      this.showTermsAndConditions();
    }
    const languageList = Language.map(lang => { return { text: lang.text, value: lang.value, isSelected: lang.value === this.selectedLanguageCulture } });
    this.LanguageListDropdown.options = [...languageList];

    this.subscriptions.push(this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (event?.url?.includes('error')) {
        this.closeTermsAndConditions('error');
      }
    }));
  }

  base64ToUtf8(base64) {
    return decodeURIComponent(escape(window.atob(base64)));
  }

  /**
   * @description Displays the terms and conditions modal for the active service Id
   * @returns void
   */
  showTermsAndConditions(): void {
    this.showLoader = true;
    this.termsAndConditionsService.getTermsAndConditionsByService(this.serviceTypeId)?.subscribe(res => {
      this.showLoader = false;
      if (res) {
        this.termsAndConditionsId = res?.TermsAndConditionsId;
        const decodedString = this.base64ToUtf8(res?.DocumentContent);
        this.termsAndConditionsId = res?.TermsAndConditionsId;
        this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(decodedString);
      } else {
        this.errorMsgType = ErrorMsgType.FETCH_ERROR;
      }
      if (this.showHyperLink) {
        this.termsAndConditionsmodalRef = this.modalService.open(this.termsAndConditionsModal, {
          backdrop: 'static',
          keyboard: false,
          windowClass: 'tc-modal-container'
        });
      }

      setTimeout(() => {
        const tcModalDiv = document.getElementById('tcModalId');
        if (tcModalDiv) {
          const anchors = tcModalDiv.getElementsByTagName('a');
          for (let i = 0; i < anchors?.length; i++) {
            anchors[i]?.addEventListener('click', function (event) {
              event.preventDefault();
              window.open(this.href, '_blank');
            });
          }
        }

        const scrollableDiv = document.getElementById('tc_scroll');
        scrollableDiv?.addEventListener('scroll', () => {
          if (this.isCheckboxDisabled) {
            if ((scrollableDiv.scrollTop + scrollableDiv.clientHeight) >= (scrollableDiv.scrollHeight - 20)) {
              this.isCheckboxDisabled = false;
            }
          }
        });
      }, 0);
    }, error => {
      this.errorMsgType = ErrorMsgType.FETCH_ERROR;
      if (this.showHyperLink) {
        this.termsAndConditionsmodalRef = this.modalService.open(this.termsAndConditionsModal, {
          backdrop: 'static',
          keyboard: false,
          windowClass: 'tc-modal-container'
        });
      }
    }
    )
  }

  /**
   * @description closes the terms and conditions modal and emits serviceId in the event emitter to the parent component
   * @returns void
   */
  termsAndConditionsAccepted(): void {
    this.isCheckboxDisabled = true;
    this.termsAndConditionsmodalRef?.close();
    this.termsAndConditionsAcceptState.emit(this.serviceTypeId);
  }

  /**
   * @description updates ther pending terms and conditions for a serviceId
   * @returns void
   */
  onAcceptTermsAndConditions(): void {
    if (this.isTCAccepted) {
      this.showLoader = true;
      this.errorMsgType = ErrorMsgType.NO_ERROR;
      this.termsAndConditionsService.acceptServiceTermsAndConditions(this.termsAndConditionsId).subscribe(res => { //this.termsAndConditionsId
        if (res) {
          let acceptedTermsAndConditions = this.userService.getUserPendingTermsAndConditions();
          if (!acceptedTermsAndConditions) {
            acceptedTermsAndConditions = [];
          } else {
            this.userService.updateUserPendingTermsAndConditions(this.serviceTypeId, 'remove');
          }
          this.termsAndConditionsAccepted();
        } else {
          this.errorMsgType = ErrorMsgType.SAVE_ERROR;
        }
        this.showLoader = false;
      }, error => {
        this.errorMsgType = ErrorMsgType.SAVE_ERROR;
      });
    }
  }

  /**
   * @description closes the terms and conditions modal reference
   * @returns void
   */
  closeTermsAndConditions(actionType: string): void {
    this.isCheckboxDisabled = true;
    this.isTCAccepted = false;
    this.termsAndConditionsmodalRef?.close();
    if (!this.showHyperLink) {
      this.onCloseTermsAndConditions.emit(actionType);
    }
  }

  /**
   * @description emites an ouput emitter for removing the widget
   */
  removeTileItem() {
    this.onWidgetRemove.emit({id: this.id, serviceTypeId: this.serviceTypeId});
  }

  ngOnDestroy(): void {
    this.subscriptions?.forEach(subscription => subscription.unsubscribe());
  }
}
